import {
  CREATE_UTILISATEUR_FAILURE,
  CREATE_UTILISATEUR_REQUEST,
  CREATE_UTILISATEUR_SUCCESS,
} from "../Types";
import { apiPost } from "../../services/apiInterceptor";

export const createUtilisateur = (userData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_UTILISATEUR_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiPost("api/users/signup", userData);

      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de l'ajout de l'utilisateur"
        );
      }

      dispatch({ type: CREATE_UTILISATEUR_SUCCESS, payload: data });

      // notification.success({
      //     message: "Utilisateur créé avec succès",
      // });
      return data;
    } catch (error) {
      dispatch({ type: CREATE_UTILISATEUR_FAILURE, payload: error?.message });

      // notification.error({
      //     message: "Échec de l'ajout de l'utilisateur.",
      // });
    }
  };
};
